const config = {
  'get-learning-objectives': ({ objectiveableId, objectiveableType }) => ({
    url: `/api/admin/learning_objectives?objectiveable_id=${objectiveableId}&objectiveable_type=${objectiveableType}`,
  }),
  'get-source-material': ({ objectiveableId, objectiveableType }) => ({
    url: `/api/admin/source_materials?sourceable_id=${objectiveableId}&sourceable_type=${objectiveableType}`,
  }),
  'generate-learning-objectives': ({ objectiveableId, objectiveableParentId }) => ({
    method: 'post', 
    url: '/api/admin/learning_objectives_generations',
    data: {
      data: {
        course_id: objectiveableId,
        course_curriculum_id: objectiveableParentId,
      }
    },
  }),
  add: (data) => ({
    method: 'post',
    url: '/api/admin/learning_objectives',
    data: { data },
  }),
  edit: ({ id, content }) => ({
    method: 'put',
    url: `/api/admin/learning_objectives/${id}`,
    data: { data: { content } },
  }),
  'move-learning-objective': ({ id, objectiveableId, position, objectiveableType = 'Course' }) => ({
    method: 'put',
    url: `/api/admin/learning_objectives/${id}/move`,
    data: {
      data: {
        objectiveable_id: objectiveableId,
        objectiveable_type: objectiveableType,
        position,
      },
    },
  }),
  delete: ({ id }) => ({
    method: 'delete',
    url: `/api/admin/learning_objectives/${id}`,
  }),
  'toggle-visibility': ({ id, ...data }) => ({
    method: 'put',
    url: `/api/admin/courses/${id}/properties`,
    data: { data },
  }),
  'get-page-components': ({ id }) => ({
    url: `/courses/${id}/content?view=page_components`,
  }),
};

export default (action, data) => config[action]?.(data) || {};
